import { render, staticRenderFns } from "./NumberItemInOrderTemplate.vue?vue&type=template&id=12a77338&scoped=true&"
import script from "./NumberItemInOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./NumberItemInOrderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a77338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a77338')) {
      api.createRecord('12a77338', component.options)
    } else {
      api.reload('12a77338', component.options)
    }
    module.hot.accept("./NumberItemInOrderTemplate.vue?vue&type=template&id=12a77338&scoped=true&", function () {
      api.rerender('12a77338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/NumberItemInOrderTemplate.vue"
export default component.exports